import "../../../assets/css/PremiumTools.css";
import React from 'react';
import FeaturesSection from '../../YouTubeThumbnailHome/FeaturesSection';

const AllToolsList = () => {
  return (
    <>
      <FeaturesSection disableWow={true} />
    </>
  );
};

export default AllToolsList;